import type { Messages } from '../i18n/messages';

/**
 * External Tools page chrome. The tool catalog itself (name, description,
 * url, icon per external-tools/ExternalToolsPage.tsx) is app-config-shaped
 * data, not UI chrome, and stays raw — see CLAUDE.md's server-data rule.
 */
export const externalToolsMessages: Messages = {
  'externalTools.nav.title': { en: 'External Tools', fun: 'External Tools' },
  'externalTools.page.title': { en: 'External tools', fun: 'External tools' },
  'externalTools.page.description': {
    en: 'Quick links to the external platforms used by the team. Open a tool to continue in its own dashboard.',
    fun: 'Fast lanes to every external platform the team lives in. Pick one and it opens its own dashboard.',
  },
};
